import "./UserData.scss";

import { useState, useEffect } from 'react';
import { api } from '../../utils/api';

export default function UserData() {
  const [userCount, setUserCount]             = useState(0);
  const [users, setUsers]                     = useState([]);
  const [search, setSearch]                   = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [hasMore, setHasMore]                 = useState(true);
  const [page, setPage]                       = useState(1);
  const [days, setDays]                       = useState(7);
  const perPage                               = 10;
  const [stats, setStats] = useState({
    new_users: 0,
    pct_with_messages: 0,
    pct_with_opportunity_response: 0,
    pct_applied_jobs: 0,
    avg_jobs_applied: 0,
  });

  useEffect(() => {
    const fetchUserCount = async () => {
      const { data } = await api.get(`/users/count`);
      setUserCount(data["count"]);
    };

    fetchUserCount();
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      const { data } = await api.get(`/users/stats`, {
        params: { days }
      });

      setStats(data);
    };

    fetchStats();
  }, [days]);

  // Update debouncedSearch after typing delay
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
      if (search.trim()) {
        setUsers([]);
      }
      setHasMore(true);
    }, 800);

    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    const fetchUsers = async () => {
      const payload = {
        query: debouncedSearch,
        per_page: perPage,
        page: page,
      };

      const { data } = await api.post(`/users/search`, payload);

      if (page === 1) {
        setUsers(data);
      } else {
        setUsers(prev => [...prev, ...data]);
      }

      // If fewer than perPage jobs came back, no more pages
      if (data.length < perPage) {
        setHasMore(false);
      }
    };

    fetchUsers();
  }, [debouncedSearch, page]);

  return (
    <div className="__user-data">
      <div className="__user-data__container">
        <div className="__user-data__header">
          User Data
        </div>
        <div className="__user-data__secondary-header">
          Total User Count
        </div>
        <div className="__user-data__user-count">
          {userCount}
        </div>

        <div className="__user-data__secondary-header">
          New users in the last
          <input
            type="number"
            min="1"
            value={days}
            onChange={(e) => setDays(Number(e.target.value))}
          />
          days
        </div>
        <div className="__user-data__user-count">
          {stats.new_users}
        </div>

        <div className="__user-data__secondary-header">
          New users who sent at least one message
        </div>
        <div className="__user-data__user-count">
          {stats.pct_with_messages?.toFixed(1)}%
        </div>

        <div className="__user-data__secondary-header">
          New users with an OPPORTUNITY agent response
        </div>
        <div className="__user-data__user-count">
          {stats.pct_with_opportunity_response?.toFixed(1)}%
        </div>

        <div className="__user-data__secondary-header">
          New users who applied to at least one job
        </div>
        <div className="__user-data__user-count">
          {stats.pct_applied_jobs?.toFixed(1)}%
        </div>

        <div className="__user-data__secondary-header">
          Average jobs applied per new user
        </div>
        <div className="__user-data__user-count">
          {stats.avg_jobs_applied?.toFixed(2)}
        </div>

        <div className="__user-data__secondary-header">
          Jobs applied to by new users
        </div>
        <div className="__user-data__user-count">
          {stats.new_user_applications}
        </div>

        <div className="__user-data__secondary-header">
          Jobs applied to by existing users
        </div>
        <div className="__user-data__user-count">
          {stats.older_user_applications}
        </div>


        <div className="__user-data__secondary-header">
          Users
        </div>
        <input
          className='__user-data__search'
          type="text"
          placeholder="Filter users by typing here..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <table className="__user-data__search-results">
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Name</th>
              <th>Onboarding done</th>
              <th>Profile</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="user">
                <td>{user.id}</td>
                <td>{user.email}</td>
                <td>{user.first_name} {user.last_name}</td>
                <td>{user.onboarding_done ? 'yes' : 'no'}</td>
                <td>
                  {user.profile?.display_name ? (
                    <a
                      href={`/a/${user.profile.display_name}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {user.profile.display_name}
                    </a>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {hasMore && users.length > 0 && (
          <div className="__user-data__load-more">
            <button
              className="ppy-btn ppy-btn-primary"
              onClick={() => setPage(prev => prev + 1)}
            >
              Load More
            </button>
          </div>
        )}
      </div>
    </div>
  );
}